import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@tech-environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';
import { CommonService } from './common.service';
import { SessionService } from './session.service';
import {
  OnboardingcoreService as sdkService,
  ClientDataOnboardingInterface,
  ClientDataOnboarding,
} from '@techrules/portallib';

import { TranslateService } from '@ngx-translate/core';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingcoreService {
  private HttpHeaders: HttpHeaders;
  private http: HttpClient;
  public showSignup: boolean = true;
  public showSmsVerification: boolean = false;
  public showSmsCode: boolean = false;
  public smsVerificationId: string;
  public accountConfirmed: boolean = false;
  public client = new ClientDataOnboarding();

  constructor(
    private commonService: CommonService,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private sdkSvc: sdkService,
    private dialogService: TechDialogsService,
    private translate: TranslateService
  ) {}

  public checkMail(mail: string, token: string): Observable<any> {
    return this.sdkSvc.checkMail(mail, token).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('apirest_checkMail', err);
        return throwError(err);
      })
    );
  }

  public createAccount(
    client: ClientDataOnboardingInterface,
    token: string
  ): Observable<any> {
    let isSMSVerification =
      localStorage.getItem('MainSettings') == 'true'
        ? JSON.parse(localStorage.getItem('SmsVerification'))
        : JSON.parse(AppConfig.settings.SMSVerification);
    return this.sdkSvc
      .createAccount(
        client,
        token,
        isSMSVerification,
        localStorage.getItem('Language')
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          let text1: string;
          let text2: string;
          this.commonService.loading$.emit(false);
          if (err.status == 400) {
            this.translate.get('k002992').subscribe((text: string) => {
              // Token: Validación vía SMS
              text1 = text;
            });
            this.translate.get('k002993').subscribe((text: string) => {
              text2 = text; //Token: Ha habido un problema en el envío del SMS. Por favor asegúrate que los datos de tu teléfono son correctos e inténtalo de nuevo.
              this.dialogService.openModalDialog('', text1, text2, '');
            });
          } else {
            this.commonService.errorManager('apirest_createaccount', err);
            return throwError(err);
          }
        })
      );
  }

  public verificationCode(
    smsVerificationId: string,
    code: string
  ): Observable<any> {
    return this.sdkSvc
      .verificationCode(
        smsVerificationId,
        code,
        localStorage.getItem('Language')
      )
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.emit(false);
          this.commonService.errorManager('activatebysms', err);
          return throwError(err);
        })
      );
  }

  public resendSms(smsVerificationId: string): Observable<any> {
    return this.sdkSvc
      .resendSms(smsVerificationId, localStorage.getItem('Language'))
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.emit(false);
          this.commonService.errorManager('activatebysms', err);
          return throwError(err);
        })
      );
  }
}
